import * as React from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import calculateDependencies from "src/scenes/overview/overview-components/calculate-dependencies";

const BorderLinearProgress = styled(LinearProgress)(() => ({
    height: 8,
    width: "40px",
    backgroundColor: "#3d3c3c",
    borderRadius: 4,
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        background: "linear-gradient(to right, #4caf5024, #59C36A)",
    },
}));

const formatString = (input) => {
    const spacedString = input.replace(/([a-z])([A-Z])/g, "$1 $2");
    return spacedString.charAt(0).toUpperCase() + spacedString.slice(1);
};

const TooltipTitleContent = ({ data }) => {
    return (
        <Stack direction="column">
            <p>{`${formatString(data.level)} accuracy`}</p>
            <p style={{ fontWeight: 200, marginTop: 0 }}>Required integrations / impact</p>
            {calculateDependencies(data && data.dependencies)}
        </Stack>
    );
};
const AccuracyLinear = ({ data }) => {
    if (!data) return null;
    const setAccuracyLevel = () => {
        if (data.level === "zero") return 0;
        if (data.level === "veryLow") return 25;
        if (data.level === "low") return 50;
        if (data.level === "medium") return 75;
        if (data.level === "high") return 100;
        return null;
    };

    return (
        <Stack spacing={2} sx={{ flexGrow: 1 }}>
            <Tooltip title={<TooltipTitleContent data={data} />}>
                <BorderLinearProgress variant="determinate" value={setAccuracyLevel()} />
            </Tooltip>
        </Stack>
    );
};

export default AccuracyLinear;
